import { Splitter } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import SlotsFilters from './SlotsFilters'
import { get } from '../../Common/api'
import SlotHistoryList from './SlotHistoryList'
import Title from 'antd/es/typography/Title'
import GlobalContext from '../GlobalContext'

export default function SlotsHistoryPage () {
  const { slots } = useContext(GlobalContext)
  const [searchedSlots, setSearchedSlots] = useState([])
  const [filter, setFilter] = useState()
  const [loading, setLoading] = useState(false)
  const [collapsed, setCollapsed] = useState(false)

  const getSlots = async () => {
    filter.scope = 'history'
    setLoading(true)
    await get({
      url: 'admin/slots',
      params: filter,
      onSuccess: (json) => {
        setSearchedSlots(json)
        setLoading(false)
        setCollapsed(true)
      },
      onFailure: () => {
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    if (filter) {
      getSlots()
    }
  }, [filter])

  useEffect(() => {
    setSearchedSlots(
      searchedSlots.map((slot) => {
        const s = slots.find((s) => s.id === slot.id)
        return s ? { ...slot, ...s } : slot
      })
    )
  }, [slots])

  return (
    <Splitter orientation='vertical' style={{ height: '87vh' }} onCollapse={() => setCollapsed(!collapsed)}>
      <Splitter.Panel
        collapsible={{ start: true, end: true, showCollapsibleIcon: true }}
        max='20%'
        resizable={false}
        size={collapsed ? '0%' : '20%'}
      >
        <SlotsFilters setFilter={setFilter} />
      </Splitter.Panel>
      <Splitter.Panel>
        <Title level={4} >{`${searchedSlots.length} Résultats`}</Title>
        <SlotHistoryList
          slots={searchedSlots}
          loading={loading}
          collapsed={collapsed}
        />
      </Splitter.Panel>
    </Splitter>
  )
}
